import axios from 'axios'
import router from '../router'
const request = axios.create({
  baseURL: '/api',
  timeout: 10000,
  withCredentials: true
})

// 全局响应拦截：未登录时强制跳转登录页
request.interceptors.response.use(
  (response) => {
    const data = response && response.data;
    const url = (response && response.config && response.config.url) || '';
    // 登录/注册接口不做未登录跳转处理
    if (url.includes('/user/login') || url.includes('/user/register')) {
      return response;
    }
    if (data && data.code !== 200) {
      const msg = data.message || '';
      if (msg.includes('未登录') || msg.includes('请先登录')) {
        router.push('/login');
        return Promise.reject(new Error('未登录'));
      }
    }
    return response;
  },
  (error) => {
    if (error && error.response && error.response.status === 401) {
      router.push('/login');
    }
    return Promise.reject(error);
  }
);

// 登录
export const login = (username, password) => {
  return request.post('/user/login', {
    username,
    password
  })
}

// 注册
export const register = (userData) => {
  return request.post('/user/register', userData)
}

// 退出登录
export const logout = () => {
  return request.post('/user/logout')
}

// 获取当前用户信息
export const getCurrentUser = () => {
  return request.get('/user/current')
}
